import type { Option } from '@/components/ui/combobox/combobox-popover';
import type { DeliveryStage } from '@/models/types.ts';

export const getDeliveryStageOptions = (): Option<DeliveryStage>[] => [
  { value: 'none', label: 'None' },
  { value: 'pending_pickup', label: 'Pending Pickup' },
  { value: 'in_delivery', label: 'In Delivery' },
  { value: 'delivered', label: 'Delivered' },
];

export const DELIVERY_STAGE_OPTIONS = getDeliveryStageOptions();

export function getDeliveryStageFilterOptions() {
  const allow = new Set(['pending_pickup', 'in_delivery']);
  return DELIVERY_STAGE_OPTIONS.filter((option) => allow.has(option.value));
}

export const DELIVERY_STAGE_FILTER_OPTIONS = getDeliveryStageFilterOptions();
